import { GameVars } from "../../GameVars";
import { BoardContainer } from "./BoardContainer";
import { GridContainer } from "./GridContainer";
import { GUI } from "./GUI";
import * as Templok from "@ravalmatic/templok-engine";

export class SpecialCell extends Phaser.GameObjects.Container {

    private cellImg: Phaser.GameObjects.Image;
    private moving: boolean;
    private specialCellType: number;
    private tintColor: number;
    private timeParticleEmitted: number;

    constructor(scene: Phaser.Scene, p: {c: number, r: number}, specialCellType: number, i: number, n: number) {

        super(scene);

        GUI.currentInstance.updateAllowed = false;

        this.specialCellType = specialCellType;
        this.timeParticleEmitted = 0;

        this.x = GridContainer.CELL_SIZE * (p.c - (Templok.Engine.GRID_SIZE / 2 - .5));
        this.y = GridContainer.CELL_SIZE * (p.r - (Templok.Engine.GRID_SIZE / 2 - .5));

        this.moving = false;

        const matchGemColor = GameVars.selectedBlock.color;

        this.cellImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "gem_0" + matchGemColor);
        this.add(this.cellImg);

        const delay = 25 * i + 400 * n + 50;

        this.scene.time.delayedCall(delay - 50, function(): void {

            this.cellImg.setFrame("gem_shine_2");

            switch (matchGemColor) {
                case 1:
                    this.tintColor = 0xFF264E;
                    break;
                case 2:
                    this.tintColor = 0xFFE12C;
                    break;
                case 3:
                    this.tintColor = 0x85FF2C;
                    break;
                case 4:
                    this.tintColor = 0x00FFFF;
                    break;
                case 5:
                    this.tintColor = 0xC74CFF;
                    break;
                case 6:
                    this.tintColor = 0xFF49A8;
                    break;
                default:
            }

            this.cellImg.setTint(this.tintColor);

            let specialIconImgName: string;

            if (this.specialCellType === Templok.ExtraHelpType.ROTATION) {
                specialIconImgName = "highlight_turn";
            } else {
                specialIconImgName = "highlight_re-roll";
            }

            const specialIcon = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", specialIconImgName);
            this.add(specialIcon);

            const scaleTweeen = this.scene.tweens.add({
                targets: this,
                scaleX: 1.05,
                scaleY: 1.05,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 80,
                yoyo: true,
                repeat: -1
            });

            this.scene.time.delayedCall(500, function(): void {

                this.moving = true;

                scaleTweeen.remove();

                this.scene.tweens.add({
                    targets: this.cellImg,
                    alpha: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 300,
                    onComplete: function(): void {
                        this.cellImg.destroy();
                    },
                    onCompleteScope: this
                });

            }, [], this);

        }, [], this);
    }

    public update(): void {

        if (this.moving) {

            // averiguar la posicion de los botones
            let p: {x: number, y: number};

            if (this.specialCellType === Templok.ExtraHelpType.ROTATION) {
                p = GUI.SPIN_BUTTON_POSITION;
            } else {
                p = GUI.REROLL_BUTTON_POSITION;
            }
 
            this.x += (p.x - this.x) * .1;
            this.y += (p.y - this.y) * .1;

            const deltaDist = Math.abs(this.x - p.x) + Math.abs(this.y - p.y);
 
            if (deltaDist < 10) {

                this.alpha *= .925;

                if (deltaDist < .5) {

                    this.moving = false;

                    GUI.currentInstance.updateAllowed = true;
    
                    BoardContainer.currentInstance.removeSpecialCell(this);
                    
                    this.destroy();
                }
            }

            const now = new Date().getTime();

            if (now - this.timeParticleEmitted > 75 && deltaDist > 25) {

                this.timeParticleEmitted = now;

                const cellImg = new Phaser.GameObjects.Image(this.scene, this.x, this.y, "texture_atlas_1", "gem_shine_2");
                cellImg.setTint(this.tintColor);
                BoardContainer.currentInstance.specialCellTrackContainer.add(cellImg);

                this.scene.tweens.add({
                    targets: cellImg,
                    alpha: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 1000,
                    onComplete: function(): void {
                        cellImg.destroy();
                    },
                    onCompleteScope: this
                });
            }
        }
    }
}
